import { parse } from 'flatted'

export const flattedParseJSON = (data: string | object) => {
  if (typeof data == 'string') return parse(data)

  return data
}
